import { useEffect } from 'react';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { useNotification } from '../../context/notificationProvider';
import { TOAST_ERROR_RESET, TOAST_ERROR_RETURN } from '../../constants/toastError';

const GlobalNotificationPikkoToast = () => {
  const [showToastPikko, setShowToastPikko] = useLocalStorage('showToastPikko');
  const { openNotification } = useNotification();

  useEffect(() => {
    const showToast = () => {
      if (showToastPikko) {
        setTimeout(() => {
          let title = "PikkoPay"
          let description = ''

          if (showToastPikko === TOAST_ERROR_RESET) {
            title = 'Pikko est vraiment désolé...'
            description = 'Le pauvre a dû recharger entièrement ses batteries. Il a perdu ton panier en chemin. On l\'examine pour que ça n\'arrive plus jamais !'
          }
          if (showToastPikko === TOAST_ERROR_RETURN) {
            title = 'Pikko est de retour'
          }

          openNotification('info', title, description, 7500);
          setShowToastPikko(null)
        }, 1000)
      }
    };

    showToast()
  }, [showToastPikko]);

  return (<></>)
};

export default GlobalNotificationPikkoToast;
